import React from 'react'
import {browserHistory} from 'react-router'
import Image from '../../../basic/image'
import styled from 'styled-components'
import getImgUrl from "../../../getImgUrl";
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';

const Wrapper = styled.div`  
  width: 25%;
  min-width: 193px;
  text-align: center;
  cursor: pointer;
  background: rgb(235, 235, 235);
  border: 1px solid white;
  
  &:hover {
    background: #0054ff;
    color: white;    
  }
`

const Card = ({href, img, label}) => (
  <Wrapper
    onClick={() => {
      browserHistory.push(href)
    }}
  >
    <div
      style={{
        padding: '20px 10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Image src={img} selectable={false} style={{maxHeight: 128, maxWidth: '100%'}}/>
      <div className='hyphenate' style={{fontWeight: 800}}>{label}</div>
    </div>
  </Wrapper>
)

const CatalogueList = () => {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return <div style={{display: 'flex', flexWrap: 'wrap'}}>
          <Card
            href={`/clutch`}
            img={getImgUrl(`/media/static/cats/sceplenie.png`)}
            label={<TranslateText id="nav_products__clutch_kit" place="bottom" />}
          />
          <Card
            href={`/clutch-disc`}
            img={getImgUrl(`/media/static/cats/disk.png`)}
            label={<TranslateText id="nav_products__clutch_disc" place="bottom" />}
          />
          <Card
            href={`/brake-pads`}
            img={getImgUrl(`/media/static/cats/kolodki.png`)}
            label={<TranslateText id="nav_products__brake_pads" place="bottom" />}
          />
          <Card
            href={`/shocks`}
            img={getImgUrl(`/media/static/cats/amortisatory.png`)}
            label={<TranslateText id="nav_products__absorbers" place="bottom" />}
          />
          <Card
            href={`/high-tension-leads`}
            img={getImgUrl(`/media/static/cats/provoda2.png`)}
            label={<TranslateText id="nav_products__wires" place="bottom" />}
          />
          {currentLanguage != 'ua' ?
            <Card
              href={`/universal-joint`}
              img={getImgUrl(`/media/static/cats/krestovina.png`)}
              label={<TranslateText id="nav_products__crossews" place="bottom" />}
            /> : ''
          }
          <Card
            href={`/cv-joint`}
            img={getImgUrl(`/media/static/cats/CV_joint_Finwhale.png`)}
            label={<TranslateText id="nav_products__shrus" place="bottom" />}
          />
          <Card
            href={`/gas-spring`}
            img={getImgUrl(`/media/static/cats/gazoviy_upor.png`)}
            label={<TranslateText id="nav_products__gas_stops" place="bottom" />}
          />
          <Card
            href={`/bearing`}
            img={getImgUrl(`/media/static/cats/podshipnik.png`)}
            label={<TranslateText id="nav_products__wheel_bearings" place="bottom" />}
          />
          <Card
            href={`/wipers-blade-fb`}
            img={getImgUrl(`/media/static/cats/wipers_fb.png`)}
            label={<TranslateText id="nav_products__wiper_blades_fb" place="bottom" />}
          />
          {/*
          <Card
            href={`/wipers-blade-hw`}
            img={getImgUrl(`/media/static/cats/wipers_hw.png`)}
            label={<TranslateText id="nav_products__wiper_blades_hw" place="bottom" />}
          />
          */}
          <Card
            href={`/wipers-blade-rx`}
            img={getImgUrl(`/media/static/cats/wipers_rx.png`)}
            label={<TranslateText id="nav_products__wiper_blades_rx" place="bottom" />}
          />
          <Card
            href={`/timing-belt`}
            img={getImgUrl(`/media/static/cats/GRM_Belt-only__Finwhale.png`)}
            label={<TranslateText id="nav_products__timing_belt" place="bottom" />}
          />
          <Card
            href={`/belt-tensioner`}
            img={getImgUrl(`/media/static/cats/GRM_Belt_Roller_Finwhale.png`)}
            label={<TranslateText id="nav_products__belt_tensioner" place="bottom" />}
          />
          <Card
            href={`/belts-v`}
            img={getImgUrl(`/media/static/cats/Belt_2__Finwhale.png`)}
            label={<TranslateText id="nav_products__drive_belts_v" place="bottom" />}
          />
          <Card
            href={`/belts-v`}
            img={getImgUrl(`/media/static/cats/Belt_1__Finwhale.png`)}
            label={<TranslateText id="nav_products__drive_belts_ribbed" place="bottom" />}
          />
          <Card
            href={`/water-pump`}
            img={getImgUrl(`/media/static/cats/pompa.png`)}
            label={<TranslateText id="nav_products__cooling_system_pumps" place="bottom" />}
          />
          <Card
            href={`/thermostat`}
            img={getImgUrl(`/media/static/cats/termostat.png`)}
            label={<TranslateText id="nav_products__termostats" place="bottom" />}
          />
          <Card
            href={`/air-filter`}
            img={getImgUrl(`/media/static/cats/vozdushniy_filter.png`)}
            label={<TranslateText id="nav_products__air_filters" place="bottom" />}
          />
          <Card
            href={`/cabin-filter`}
            img={getImgUrl(`/media/static/cats/salonniy_filter.png`)}
            label={<TranslateText id="nav_products__cabin_filters" place="bottom" />}
          />
          <Card
            href={`/fuel-filter`}
            img={getImgUrl(`/media/static/cats/toplivniy_filter.png`)}
            label={<TranslateText id="nav_products__fuel_filters" place="bottom" />}
          />
          <Card
            href={`/oil-filter`}
            img={getImgUrl(`/media/static/cats/maslyanoi_filter.png`)}
            label={<TranslateText id="nav_products__oil_filters" place="bottom" />}
          />
          <Card
            href={`/spark-plugs-iridium`}
            img={getImgUrl(`/media/static/cats/spark_plugs_iridium.png`)}
            label={<TranslateText id="nav_products__spark_plug_iridium" place="bottom" />}
          />
          <Card
            href={`/spark-plugs-nicu`}
            img={getImgUrl(`/media/static/cats/spark_plugs_ni_cu.png`)}
            label={<TranslateText id="nav_products__spark_plug_nicu" place="bottom" />}
          />
          <Card
            href={`/ball-joint`}
            img={getImgUrl(`/media/static/cats/sharovaya.png`)}
            label={<TranslateText id="nav_products__ball_joint" place="bottom" />}
          />
          <Card
            href={`/tie-rod-ends`}
            img={getImgUrl(`/media/static/cats/nakonechnik.png`)}
            label={<TranslateText id="nav_products__tie_rod_ends" place="bottom" />}
          />
          <Card
            href={`/silent-block`}
            img={getImgUrl(`/media/static/cats/silentblock.png`)}
            label={<TranslateText id="nav_products__silent_block" place="bottom" />}
          />
          <Card
            href={`/stabilizer-link`}
            img={getImgUrl(`/media/static/cats/stabilizer_racks.png`)}
            label={<TranslateText id="nav_products__stabilizer_link" place="bottom" />}
          />
          <Card
            href={`/ignition-coil`}
            img={getImgUrl(`/media/static/cats/katushki.png`)}
            label={<TranslateText id="nav_products__katushki" />}
          />
        </div>
      }}
    </CurrentLanguageContext.Consumer>
  )
}

export default CatalogueList



// WEBPACK FOOTER //
// ./src/finwhale/common/catalogue-list/Desktop.js